let scrollerMixin = {
    activated() {
        this.$refs.scroller.scrollTo(0, this.$route.meta.scrollTop);
    },
}

export default scrollerMixin;
